import { useAuth } from '@/hooks/useAuth'

/** The viewer's permission atoms from `/auth/me`, plus the loading flag route guards must wait for. */
export function useViewerPermissions(): {
	permissions: string[]
	tenantId: string | null
	/** The viewer's own tenant slug from `/auth/me` (TO-628); `null` when absent. Builds `/t/{slug}/…` URLs. */
	tenantSlug: string | null
	userId: string
	isLoading: boolean
} {
	const { user, isLoading } = useAuth()
	return {
		permissions: user?.permissions ?? [],
		tenantId: user?.tenantId ?? null,
		tenantSlug: user?.tenantSlug ?? null,
		userId: user?.userId ?? '',
		isLoading,
	}
}
